import { render, staticRenderFns } from "./PercentageTreatments.vue?vue&type=template&id=2435a064&"
import script from "./PercentageTreatments.vue?vue&type=script&lang=js&"
export * from "./PercentageTreatments.vue?vue&type=script&lang=js&"
import style0 from "./PercentageTreatments.vue?vue&type=style&index=0&id=2435a064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports